'use client';

import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';

import { persistLanguage } from '~/lib/i18n/persist-language';

export function LanguageToggleButton({ className }: { className?: string }) {
  const { i18n } = useTranslation();

  const locales = (i18n.options.supportedLngs as string[] | undefined)?.filter(
    (locale) => locale.toLowerCase() !== 'cimode',
  ) ?? ['en'];

  const nextLocale =
    locales.find((locale) => locale !== i18n.language) ?? i18n.language;

  const nextLabel = nextLocale.toUpperCase();

  const toggleLanguage = useCallback(async () => {
    await persistLanguage(i18n, nextLocale);
    window.location.reload();
  }, [i18n, nextLocale]);

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      aria-label={`Switch language to ${nextLabel}`}
      className={className}
    >
      <span className="text-xs font-semibold uppercase tracking-wide">
        {nextLabel}
      </span>
    </Button>
  );
}
